
export default {
  SET_NEXT_SEQ_CODE: (state, payload) => state.nextSeqCode = payload,

  SET_PROJECT: (state, payload) => state.project = payload,
  SET_PROJECTS: (state, payload) => state.projects = payload,

  SET_PROJECT_NAMES: (state, payload) => {
    state.projectNames = payload;
    (payload || []).forEach(p => state.projectsMap[p.Id] = p.Name);
  },

  SET_PROJECT_STATUSES: (state, payload) => {
    state.projectStatuses = payload;
    (payload || []).forEach(ps => state.statusesMap[ps.id] = ps.description)
  },

  SET_PROJECT_VESSELS: (state, payload) => { 
    state.projectVessels = payload;

    let vIds = [];
    (payload || []).forEach(v =>  vIds.push(v.Id));
    state.projectVesselIds = vIds;
  }
}